import React from 'react';
import { Dial } from './Dial';
type WatchRenderProps = {
  face?: 'cream' | 'charcoal';
  className?: string;
};

/** Hero render placeholder for the True Twelve watch. [NEED FROM ABBY: product renders] */
export function WatchRender({
  face = 'cream',
  className = ''
}: WatchRenderProps) {
  const strap = face === 'cream' ? 'bg-[#CDBFAE]' : 'bg-charcoal';
  return <div className={`relative aspect-[3/4] ${className}`} role="img" aria-label={`True Twelve watch render with a ${face === 'cream' ? 'cream' : 'deep charcoal'} face, XII at the top and twelve gold indices`} data-id="element-512" data-mp="3ly8vp2urdhpq">
      <div className={`absolute left-1/2 top-0 h-full w-[38%] -translate-x-1/2 rounded-[3px] ${strap}`} data-id="element-513" data-mp="3c0ugf6kkmyz0" />
      <div className="absolute left-[90.5%] top-1/2 h-[6%] w-[4%] -translate-y-1/2 rounded-r-sm bg-gold" data-id="element-514" data-mp="3h07e6mczdqgd" />
      <div className="absolute left-1/2 top-1/2 aspect-square w-[84%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold p-[2.2%] shadow-[0_40px_60px_-40px_rgba(30,30,30,0.55)]" data-id="element-515" data-mp="330pjjqd07iz3">
        <div className="h-full w-full rounded-full bg-[#CBB083] p-[1.6%]" data-id="element-516" data-mp="3i07w4hutsq3f">
          <div className={`h-full w-full rounded-full ${face === 'cream' ? 'bg-cream' : 'bg-[#232220]'}`} data-id="element-517" data-mp="3dzo05hlznsiv">
            <Dial tone={face === 'cream' ? 'gold' : 'night'} numerals="twelve" star={false} wordmark className="h-full w-full" data-id="element-518" data-mp="3rzp10x296zyc" />
          </div>
        </div>
      </div>
    </div>;
}